import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdesaoService } from '../../../../services/adesao/adesao.service';
import { BloqueioAdesao } from '../../../../interfaces/adesao.dto';
import { BrlPipe } from '../../../../utils/brl.pipe';

/**
 * Faturas de assinatura cancelada que a Fila não cobra (multa, anuidade de mês anterior) mas que
 * fazem o CartãoSiM recusar a adesão. Tudo vai para ticket do financeiro (decisão de 03/11/2026:
 * a Fila não cancela multa). Sem bloqueio emite false e a oferta aparece.
 */
@Component({
  selector: 'app-bloqueio-adesao-sim',
  standalone: true,
  imports: [CommonModule, BrlPipe],
  templateUrl: './bloqueio-adesao-sim.component.html',
  styleUrl: './bloqueio-adesao-sim.component.scss',
})
export class BloqueioAdesaoSimComponent implements OnChanges {
  @Input() personId = 0;
  @Input() naPausa = false;
  @Output() temBloqueio = new EventEmitter<boolean>();

  bloqueios: BloqueioAdesao[] = [];
  copiado = false;
  private carga = 0;

  constructor(private adesaoService: AdesaoService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['personId']) await this.carregar();
  }

  async carregar(): Promise<void> {
    const n = ++this.carga;
    const lista = this.personId ? await this.adesaoService.bloqueios(this.personId) : [];
    if (n !== this.carga) return;
    this.bloqueios = lista ?? [];
    this.temBloqueio.emit(lista === null || lista.length > 0);
  }

  rotulo(b: BloqueioAdesao): string {
    return b.tipo === 'multa' ? 'Multa de cancelamento' : b.tipo === 'anual' ? 'Anuidade' : 'Fatura';
  }

  async copiarParaTicket(): Promise<void> {
    const linhas = this.bloqueios.map(b =>
      `- ${this.rotulo(b)} · fatura ${b.billId} · assinatura ${b.subscriptionId} (${b.plano}) · vencimento ${b.vencimento} · R$ ${b.valor.toFixed(2).replace('.', ',')}`);
    const texto = ['Faturas em aberto de assinatura cancelada impedindo nova adesão ao CartãoSiM:', ...linhas].join('\n');
    try {
      await navigator.clipboard.writeText(texto);
      this.copiado = true;
      setTimeout(() => (this.copiado = false), 2500);
    } catch {
      this.copiado = false;
    }
  }
}
